import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {DecimalPipe} from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { OfferteService } from 'src/app/shared/dataservices/offerte.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { OfferteInkoop } from 'src/app/shared/model/offerte';

@Component({
  selector: 'app-offerte-edit-lines',
  templateUrl: './offerte-edit-lines.component.html',
  styleUrls: ['./offerte-edit-lines.component.less']
})
export class OfferteEditLinesComponent implements OnInit {

  @Input() offerteID : number;
  offerteInkoopList : Array<OfferteInkoop> = null;
  emptyLine : OfferteInkoop = new OfferteInkoop();

  constructor(private relatiesService: RelatiesService,
    private objectenService: ObjectenService,
    private offerteService: OfferteService,
    private toastr: ToastrService
    ) { }

  ngOnInit(): void {
    this.createEmptyLine();
  }

  createEmptyLine() {
    // if(this.emptyLine == null) {
      this.emptyLine = new OfferteInkoop();
    // }
    this.emptyLine.ID = 0;
    this.emptyLine.BedrijfNummer = -2
    // this.emptyLine.BedrijfNummer =null;
    // this.emptyLine.InvoerDatum = null;
    // this.emptyLine.KostenEuro = null;
    // this.emptyLine.StatusCodeID = null;
    // this.emptyLine.Toelichting = null;
    // this.emptyLine.MutatieDatum = null;
    this.emptyLine.OfferteID = this.offerteID;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.offerteID) {
      this.offerteInkoopList = null;
      this.emptyLine = null;
      return
    }
    this.offerteService.getOfferteInkoop(this.offerteID).subscribe(data => {
      this.offerteInkoopList =  data;
      this.createEmptyLine();
    })
  }


  newLine(line : OfferteInkoop) {
    window.setTimeout( () => {
      this.createEmptyLine();
    },100)
    this.offerteInkoopList.push(line);
  }


  deleted(id: any) {
    this.offerteInkoopList.forEach( (item, index) => {
      if(item.ID === id) {
        this.offerteInkoopList.splice(index,1);
      }
  });
  }


  sum() {
    let totaal =0;
    if (this.offerteInkoopList != null) {
      this.offerteInkoopList.forEach( e => totaal += (e.KostenEuro *1))
    }
    return totaal;
  }



}
